var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.views),function(view){return _c('b-btn',{key:view.key,staticClass:"text-capitalize mr-2",class:{ 'border-primary': _vm.galleryView === view.key },attrs:{"variant":"light","size":"sm","pill":""},on:{"click":function($event){return _vm.$store.dispatch('galleryIndex/setView', view.key)}}},[_vm._v(" "+_vm._s(view.label)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }